module.exports = __webpack_public_path__ + "img/8.e80ca49a.jpg";